import { Controller } from "@hotwired/stimulus";

// Tri-state theme switcher: auto | light | dark, persisted in localStorage.
// The initial <html class="dark"> is set by an inline head script (no flash);
// this controller drives the footer control and keeps it in sync.
export default class extends Controller {
	static targets = ["auto", "light", "dark", "toggle"];

	connect() {
		this.media = window.matchMedia("(prefers-color-scheme: dark)");
		this.onSystemChange = () => {
			if (this.preference === "auto") this.apply();
		};
		this.media.addEventListener("change", this.onSystemChange);
		this.reflect();
	}

	disconnect() {
		this.media.removeEventListener("change", this.onSystemChange);
	}

	get preference() {
		return localStorage.getItem("od-theme") || "auto";
	}

	select(event) {
		localStorage.setItem("od-theme", event.currentTarget.dataset.themeValue);
		this.apply();
		this.reflect();
	}

	toggle() {
		const dark = document.documentElement.classList.contains("dark");
		localStorage.setItem("od-theme", dark ? "light" : "dark");
		this.apply();
		this.reflect();
	}

	apply() {
		const p = this.preference;
		const dark = p === "dark" || (p === "auto" && this.media.matches);
		document.documentElement.classList.toggle("dark", dark);
		this.targets.find("toggle")?.setAttribute("aria-pressed", String(dark));
	}

	reflect() {
		const p = this.preference;
		this.targets.find("toggle")?.setAttribute("aria-pressed", String(document.documentElement.classList.contains("dark")));
		for (const name of ["auto", "light", "dark"]) {
			if (!this[`has${name[0].toUpperCase()}${name.slice(1)}Target`]) continue;
			const el = this[`${name}Target`];
			const active = p === name;
			el.setAttribute("aria-pressed", String(active));
			el.classList.toggle("bg-grafite-700", active);
			el.classList.toggle("text-white", active);
		}
	}
}
